import { Resource } from '../../../../../Resource/Types';

// Mirrors Organizations::UseCase permission types offered to admins. `hidden`
// is server-only and never reaches this UI.
export type PermissionType = 'organization' | 'private' | 'client-groups';

export interface PermissionOption {
  value: PermissionType;
  label: string;
}

export interface ClientGroup {
  id: number;
  name: string;
  membersCount: number;
}

export interface CollaboratorAccess {
  permissionType: PermissionType;
  clientGroupIds: number[];
  options: PermissionOption[];
  clientGroups: ClientGroup[];
}

export type CollaboratorAccessResource = Resource<CollaboratorAccess>;

export interface Draft {
  permissionType: PermissionType;
  clientGroupIds: number[];
}

export const draftFrom = (resource: CollaboratorAccessResource): Draft => ({
  permissionType: resource.payload.permissionType,
  clientGroupIds: resource.payload.clientGroupIds,
});

// Specific Groups needs at least one group; every other choice is always valid.
export const isDraftValid = (draft: Draft): boolean =>
  draft.permissionType !== 'client-groups' || draft.clientGroupIds.length > 0;
